import { useState } from "react"

import { useEffect } from "react"

export const useDebounce = (value: string, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay)
    return () => clearTimeout(timer)
  }, [value, delay])

  return debouncedValue
}
// example usage:
// use for search input to avoid sending too many requests
// const debouncedValue = useDebounce(value, 500)
// console.log(debouncedValue)
